module.exports = __webpack_public_path__ + "img/collection-weddingRingsPolar@2x.2d47189.webp";